<template>
  <div>
    <img src="@/assets/tarjeta_promocion_freidora_2024.jpg" style="width: 100%" />
    <p class="tituloTarjeta">Y TÚ... ¿YA TIENES TU AIRFRYER?</p>
    <p>
      Contrata cualquiera de estos seguros y participa en el sorteo de una freidora de aire de la marca Cosori. Comer rico y saludable nunca fue tan fácil.
    </p>
    <div class="container-flex-sin-margen">
    <p>
      <ul style="list-style-type: disc">
        <li>Hogar</li>
        <li>Decesos</li>
        <li>Salud</li>
        <li>Patinetes y bicicletas</li>
      </ul>
    </p>
    <p>
      <ul style="list-style-type: disc">
        <li>Negocios</li>
        <li>Accidentes</li>
        <li>Mascotas</li>  
        <li>Movilidad personal</li> 
      </ul>
    </p>
    </div>
    <p class="container-flex">
     
      <a href="https://www.mmtseguros.com/hubfs/Bases_Campanas/Bases-Promo-Sorteo-Freidora.pdf?hsLang=es-es"
        target="_blank" class="link"> Consulta condiciones aquí</a>
    </p>

    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llama e infórmate
        </button>
      </a>
    </p>
   
  </div>
</template>

<script>
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}


.container-flex-sin-margen {
  display: flex;
  flex-direction: row;
 
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
